import * as yup from 'yup'

import i18n from '../i18n'

const tMessage = (key: string, fallback: string) => () => i18n.t(key, fallback) || fallback

export const OldPasswordInputSchema = yup.object().shape({
  oldPassword: yup.string().required(tMessage('passwordIsRequired', 'Password is required')),
})
